import styled from 'styled-components'

import { isLoggedIn } from 'core/actions/helpers/tokenHelpers'
import { Clickable } from 'core/components'
import { R } from 'core/helpers'
import { useAccountOptions, useBorrowerBaseUrl } from 'core/hooks'
import { Option } from 'core/hooks/useAccountOptions'

const canDisplayLink = (option?: Option): boolean => {
  const { action, href, label, disabled, hide } = option || {}

  return disabled !== true && hide !== true && !!label && (!!action || !!href)
}

const FooterLinks = () => {
  const baseUrl = useBorrowerBaseUrl()

  const options = useAccountOptions({ isMobile: false })

  const helpOption = R.find(options ?? [], (option) => option.icon === 'help')

  const isloggedIn = isLoggedIn()

  return (
    <Links>
      {!isloggedIn ?
        <>
          <Clickable variant='link' to={`${baseUrl}/login`}>
            Login
          </Clickable>

          {!R.isNil(helpOption) && canDisplayLink(helpOption) && (
            <Clickable variant='link' href={helpOption.href!}>
              {helpOption?.label}
            </Clickable>
          )}
        </>
      : <>
          {R.pipe(
            options ?? [],
            R.filter(canDisplayLink),
            R.map((option) => (
              <Clickable
                variant='link'
                key={option?.label}
                to={option?.action ? `${baseUrl}${option.action}` : undefined}
                href={option?.href}
              >
                {option?.label}
              </Clickable>
            )),
          )}
        </>
      }
    </Links>
  )
}

export default FooterLinks

const Links = styled.div`
  display: inline-flex;
  flex-direction: column;
  gap: 16px;
`
